import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import {
  callApi,
  fnGetDataSet,
  fnGetTableById,
  fnSave,
} from "@shared/api/restApi";
import {
  getInitFormData,
  CalAm,
  applySlip,
  CalAmBulk,
  setUmByFgUm,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showResizablePopupModal } from "@widgets/CommonModal";
import SN_SAL_STX_REG_001_POP_001 from "@menu/SAL/SN_SAL_STX_REG_001/SN_SAL_STX_REG_001_POP_001";
import SnButton from "@shared/components/SnButton";
import SnLabel from "@shared/components/SnLabel";
import SnComboBox from "@shared/components/SnComboBox";
import { fnCheckAutoProcessV2 } from "../common/sn-sal-util";
import {
  CellValueChangedEvent,
  SnGridRef,
} from "@shared/components/GridV2/SnGridTypes";
import { dateToString } from "@shared/utils/DateUtils";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { RowNode } from "ag-grid-community";

interface Props {
  Menuprops: menuInfo;
}

// 매출등록
const SN_SAL_STX_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo, config } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
    grid2: React.createRef<SnGridRef>(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  const sotypeRef = useRef<any[]>([]);
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedDtDocu, setSelectedDtDocu] = useState<string>("");
  const [tpUmValue, settpUmValue] = useState<String>("001");

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();

        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });

        const payload = {
          id: "sotype",
          params: { cd_firm: userInfo.cd_firm },
        };
        const data = await fnGetTableById(payload);
        if (Array.isArray(data) && data.length > 0) {
          sotypeRef.current = data;
        }
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid2.length > 0
    ) {
      onActivate(Menuprops.nodeData);
    }
  }, [columns, Menuprops]);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
  }));

  const onSearch = async (searchData: any) => {
    const modifiedRowsH = getGridCurrent("grid1").getChange();
    const modifiedRowsL = getGridCurrent("grid2").getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      } else if (confirm === undefined) {
        return;
      }
    }

    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      const params = {
        id: "sn_sal_stx_reg_001_01",
        params: searchDataToUse,
      };

      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
      });
    } catch (error: any) {}
  };

  const onInsert = async () => {
    try {
      getGridCurrent("grid1")?.addRow({});
    } catch (error: any) {}
  };

  const onBeforeAddRowH = (): any => {
    try {
      const modifiedRowsH = getGridCurrent("grid1").getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("alter", "수정중인 건이 있습니다.");
        return false;
      }

      const searchInfo = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      return {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        cd_gp: userInfo.cd_gp,
        dt_sales: today,
        dt_col_p: today,
        cd_cust: searchInfo.cd_cust,
        nm_cust_sort: searchInfo.nm_cust_sort,
        cd_cust_sales: searchInfo.cd_cust,
        nm_cust_sales: searchInfo.nm_cust_sort,
        cd_cust_col: searchInfo.cd_cust,
        nm_cust_col: searchInfo.nm_cust_sort,
        fg_trns: "1",
        cd_exch: "000",
        rt_exch: 1,
        fg_vat: "11",
        fg_etax: "1",
        yn_end: "Y",
        st_etax: "",
        cd_fin: "",
        am_k_col_s: 0,
        yn_autoprocess: "N",
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        am_col_s: 0,
        dy_pay: 0,
        qt_grossweight: 0,
        qt_netweight: 0,
        yn_etax: "N",
        yn_docu: "N",
      };
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow = () => {
    try {
      getGridCurrent("grid1")?.stopEditing();
      return getGridCurrent("grid2")?.addRow({});
    } catch (error: any) {}
  };

  const onBeforeAddRowL = (): any => {
    try {
      const focusedNodeH = getGridCurrent("grid1").focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        getGridCurrent("grid1").requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const maxNoLine = getGridCurrent("grid2").getMaxValue("no_line");
      const selectedRows = getGridCurrent("grid1").getSelectedRows();
      return {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_sales: selectedRows[0].data?.no_sales,
        no_line: maxNoLine + 1,
        fg_io: "1",
        qt: 0,
        um: 0,
        am: 0,
        um_k: 0,
        am_k: 0,
        am_vat: 0,
        um_supply: 0,
        am_supply: 0,
        no_line_isu: 0,
        no_line_so: 0,
        no_line_pjt: 0,
        no_line_sales_src: 0,
      };
    } catch (error: any) {}
  };

  const onDelete = async () => {
    if (getGridCurrent("grid1")?.getDisplayedRowCount() < 1) return;

    if (await fnCheckAutoProcessV2(getGridCurrent("grid1"))) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    const focusedNodeH = getGridCurrent("grid1")?.focusedRowNode();
    const result = await checkDelete(focusedNodeH.data);
    if (!result) return;

    getGridCurrent("grid2")?.deleteAllRows();
    getGridCurrent("grid1")?.deleteSelectedRows();

    const realDeletedRows = getGridCurrent("grid1").getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();
      return;
    }

    await onSave();
  };

  const onDeleteRow = async () => {
    const rowCount = getGridCurrent("grid2").getDisplayedRowCount();
    if (rowCount === 0) return;

    if (await fnCheckAutoProcessV2(getGridCurrent("grid1"))) return;

    const focusedNodeH = getGridCurrent("grid1")?.focusedRowNode();
    const result = await checkDelete(focusedNodeH.data);
    if (!result) return;

    getGridCurrent("grid2")?.deleteSelectedRows();
    onAfterSetFooter();

    if (rowCount === 1 && focusedNodeH.rowIndex !== null) {
      gridRefs.current["grid1"].current?.deleteRowByIndex(
        focusedNodeH.rowIndex
      );
    }
  };

  const onSave = async () => {
    try {
      getGridCurrent("grid1").stopEditing();
      getGridCurrent("grid2").stopEditing();

      if (await fnCheckAutoProcessV2(getGridCurrent("grid1"))) return false;

      const requiredValuesCheckH =
        getGridCurrent("grid1").requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL =
        getGridCurrent("grid2").requiredValuesCheck();
      if (!requiredValuesCheckL) return false;

      const salesHChanges = getGridCurrent("grid1").getChange();
      const salesLChanges = getGridCurrent("grid2").getChange();

      const headerInserts = salesHChanges.insert ?? [];
      const lineInserts = salesLChanges.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }
      if (
        salesHChanges.modifiedRowcount === 0 &&
        salesLChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      if (headerInserts.length > 0) {
        const focusedRowNodeH = getGridCurrent("grid1").focusedRowNode();
        const noSlip = await applySlip({
          cd_column: "no_sales",
          cd_module: Menuprops.cd_module,
          no_line: 3,
          cd_prefix: "STX",
          dt: focusedRowNodeH.data.dt_sales,
          girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
          inserts: [salesHChanges, salesLChanges],
          cd_menu: Menuprops.cd_menu,
        });
      }

      const saveData = {
        salesh: salesHChanges,
        salesl: salesLChanges,
      };
      const ok = await fnSave("SN_SAL_STX_REG_001_SAVE_01", saveData);
      if (!ok) {
        getGridCurrent("grid1").resetUpdate(true);
        getGridCurrent("grid2").resetUpdate(true);
        return false;
      }

      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();
      return true;
    } catch (error: any) {
      getGridCurrent("grid1").resetUpdate(true);
      getGridCurrent("grid2").resetUpdate(true);
      return false;
    }
  };

  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const selectedData = {
        cd_firm: nodeData.cd_firm,
        cd_biz: nodeData.cd_biz || userInfo.cd_biz,
        fg_search: nodeData.no_so || nodeData.no_sales,
        dt_from: nodeData.dt_so || nodeData.dt_dlv || nodeData.dt_sales,
        dt_to: nodeData.dt_so || nodeData.dt_dlv || nodeData.dt_sales,
      };
      const searchData = {
        ...formData,
        ...selectedData,
        cd_emp: "",
        nm_emp: "",
      };
      setFormData(searchData);
      onSearch(searchData);
    }
  };

  const onPrint = async () => {
    getGridCurrent("grid1").stopEditing();
    getGridCurrent("grid2").stopEditing();

    const selectedRow = getGridCurrent("grid1").getSelectedRows();
    if (selectedRow.length < 1) {
      await showDialog("alter", "선택된 매출정보가 없습니다.");
      return;
    }
    return {
      cd_firm: userInfo.cd_firm,
      cd_biz: selectedRow[0].cd_biz,
      no_sales: selectedRow[0].no_sales,
    };
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnApply") {
      const salSalesHChanges = getGridCurrent("grid1").getChange().insert;
      if (salSalesHChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
        cd_cust: selectedFormData.cd_cust,
        nm_cust_sort: selectedFormData.nm_cust_sort,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
        fg_trns: selectedFormData.fg_trns,
      };

      const component = (
        <SN_SAL_STX_REG_001_POP_001 selectedData={selectedData} />
      );
      const result = await showResizablePopupModal({
        title: "출하적용",
        children: component,
        validation: true,
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      const lineResult: any[] = result[1];

      const focusedRowNodeH = getGridCurrent("grid1").focusedRowNode();
      if (focusedRowNodeH && headerResult[0]) {
        for (const key in headerResult[0]) {
          if (["cd_emp", "nm_emp", "cd_dept", "cd_gp"].includes(key)) continue;
          focusedRowNodeH.setDataValue(key, headerResult[0][key], "noEvent");
        }

        if (headerResult[0].cd_cust_sales) {
          focusedRowNodeH.setDataValue(
            "cd_cust_sales",
            headerResult[0].cd_cust_sales,
            "noEvent"
          );
          focusedRowNodeH.setDataValue(
            "nm_cust_sales",
            headerResult[0].nm_cust_sales,
            "noEvent"
          );
          focusedRowNodeH.setDataValue(
            "cd_cust_col",
            headerResult[0].cd_cust_sales,
            "noEvent"
          );
          focusedRowNodeH.setDataValue(
            "nm_cust_col",
            headerResult[0].nm_cust_sales,
            "noEvent"
          );
        } else {
          focusedRowNodeH.setDataValue(
            "cd_cust_sales",
            headerResult[0].cd_cust,
            "noEvent"
          );
          focusedRowNodeH.setDataValue(
            "nm_cust_sales",
            headerResult[0].nm_cust_sort,
            "noEvent"
          );
          focusedRowNodeH.setDataValue(
            "cd_cust_col",
            headerResult[0].cd_cust,
            "noEvent"
          );
          focusedRowNodeH.setDataValue(
            "nm_cust_col",
            headerResult[0].nm_cust_sort,
            "noEvent"
          );
        }
        focusedRowNodeH.setDataValue("fg_io", headerResult[0].fg_io, "noEvent");
      }
      lineResult.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow();
          if (addedNode) {
            for (const key in result) {
              if (key === "no_line") continue;
              addedNode.setDataValue(key, result[key], "noEvent");
            }
            addedNode.setDataValue("no_sales_tmp", result.no_io, "noEvent");
            addedNode.setDataValue("no_so", result.no_order, "noEvent");
            addedNode.setDataValue(
              "no_line_so",
              result.no_line_order,
              "noEvent"
            );
            addedNode.setDataValue("qt", result.qt_app, "noEvent");
            addedNode.setDataValue("no_isu", result.no_io, "noEvent");
            addedNode.setDataValue("no_line_isu", result.no_line, "noEvent");
          }
        }
      });
      gridRefs.current["grid1"].current?.applyBlock(focusedRowNodeH);
      await CalAmBulk(
        gridRefs.current["grid1"],
        gridRefs.current["grid2"],
        "rt_exch"
      );
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id == "deleteRow") {
      onDeleteRow();
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_sales = selectedRow.no_sales;
      const dt_sales = selectedRow.dt_sales || "";
      getGridCurrent("grid2").selectAndFocusRow(0);
      setSelectedDocu(no_sales);
      setSelectedDtDocu(dt_sales);
    } else {
      return;
    }
  };

  const onCellValueChangedH = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    if (colId === "cd_cust") {
      rowNode.setDataValue("cd_cust_sales", rowData.cd_cust);
      rowNode.setDataValue("nm_cust_sales", rowData.nm_cust_sort);
      rowNode.setDataValue("cd_cust_col", rowData.cd_cust);
      rowNode.setDataValue("nm_cust_col", rowData.nm_cust_sort);
    }
    await CalAmBulk(
      gridRefs.current["grid1"],
      gridRefs.current["grid2"],
      colId
    );
  };

  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    await CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };

  const onAfterSetFooter = async () => {
    const focusedNodeH = getGridCurrent("grid1").focusedRowNode();
    const footerData = getGridCurrent("grid2").getFooterData();
    if (focusedNodeH) {
      if (focusedNodeH.data.fg_io === "2") {
        focusedNodeH.setDataValue("am", footerData.am * -1);
        focusedNodeH.setDataValue("am_k", footerData.am_k * -1);
        focusedNodeH.setDataValue("am_vat", footerData.am_vat * -1);
        focusedNodeH.setDataValue("am_supply", footerData.am_supply * -1);
      } else {
        focusedNodeH.setDataValue("am", footerData.am);
        focusedNodeH.setDataValue("am_k", footerData.am_k);
        focusedNodeH.setDataValue("am_vat", footerData.am_vat);
        focusedNodeH.setDataValue("am_supply", footerData.am_supply);
      }
    }
  };

  const changeUmBatch = async () => {
    if (getGridCurrent("grid2").getDisplayedRowCount() === 0) return;

    if (!tpUmValue) {
      await showDialog("alter", "단가유형을 선택하시기 바랍니다.");
      return;
    }

    const focusedRow = getGridCurrent("grid1").focusedRowNode();
    if (focusedRow) {
      if (focusedRow.data.fg_etax === "2") {
        await showDialog(
          "alter",
          "전자세금전표구분이 취소인 건은 수정할 수 없습니다."
        );
        return;
      }
    }

    const addedDataRows = getGridCurrent("grid2").getChange();
    const targetRows = addedDataRows.insert ?? [];
    if (targetRows.length < 1) {
      await showDialog("alter", "신규가 아닌건이 존재 합니다.");
      return;
    }
    const rowNodesL: RowNode[] = [];
    gridRefs.current["grid2"].current?.forEachFilteredNode(
      (rowNode: RowNode) => {
        rowNodesL.push(rowNode);
      }
    );
    await setUmByFgUm(focusedRow.data, rowNodesL, "dt_sales", tpUmValue);
    await CalAmBulk(
      gridRefs.current["grid1"],
      gridRefs.current["grid2"],
      "rt_exch"
    );
  };

  /**
   * 회계처리, 전자세금계산서 상태 확인 메서드
   * @param header 헤더 데이터
   */
  const checkDelete = async (header: any) => {
    if (!header) return false;

    const params = {
      cd_firm: userInfo.cd_firm,
      no_sales: header.no_sales,
    };
    const result = await callApi(
      "SN_SAL_STX_REG_001_SAVE_01_btnDelete",
      params
    );

    const status = result.status;
    const data = result.data;
    if (!status) return false;

    const yn_docu = data.yn_docu;
    const no_docu = data.no_docu;
    const yn_end = data.yn_end ?? "Y";
    const yn_etax = data.yn_etax ?? "N";
    const fg_etax = data.fg_etax ?? "1";
    const st_etax = data.st_etax ?? "";

    if (
      yn_docu === "Y" ||
      (no_docu !== null && no_docu !== "" && no_docu !== undefined)
    ) {
      await showDialog(
        "alter",
        "회계처리된 매출 건입니다. 취소 후 진행해주시기 바랍니다."
      );
      return false;
    }

    if (yn_etax === "Y" && yn_end === "N") {
      if (fg_etax === "1") {
        await showDialog(
          "alter",
          "전자세금계산서 취소 처리한 매출전표가 존재합니다. 해당 건 삭제 후 진행해 주시기 바랍니다."
        );
        return false;
      } else if (fg_etax === "2") {
        await showDialog(
          "alter",
          "전자세금계산서 재발행 처리한 매출전표가 존재합니다. 해당 건 삭제 후 진행해 주시기 바랍니다."
        );
        return false;
      }
    }

    if (yn_etax === "Y" && yn_end === "Y") {
      if (st_etax === "C") {
        await showDialog(
          "alter",
          "전자세금계산서 신고완료된 건은 삭제하실 수 없습니다."
        );
        return false;
      } else if (st_etax === "S") {
        await showDialog(
          "alter",
          "전자세금계산서 신고중인 건은 삭제하실 수 없습니다."
        );
        return false;
      }
    }

    return true;
  };

  const getRowStyle = (params: any) => {
    if (params.data?.fg_io === "2") {
      return { color: "red" };
    }
    return null;
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onCellValueChanged: onCellValueChangedH,
          onBeforeAddRow: onBeforeAddRowH,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChanged,
          onBtnDeleteClick: onGrid2BtnsClick,
          onBeforeAddRow: onBeforeAddRowL,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "매출정보",
              getRowStyle: getRowStyle,
            }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: ["no_sales"],
            }}
            header={
              <div>
                <SnButton
                  text={"출고적용"}
                  onClick={() => {
                    onGrid1BtnsClick("btnApply");
                  }}
                />
                <SnButton
                  text={"전자계산"}
                  onClick={() => {
                    onGrid1BtnsClick("btnProject");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              rowSelection: "multiple",
              title: "상세정보",
              getRowStyle: getRowStyle,
            }}
            events={grids.grid2.events}
            header={
              <div className="relative flex space-x-4">
                <SnLabel text="단가유형" type="string" />
                <div style={{ width: 180 }}>
                  <SnComboBox
                    defaultValue={"001"}
                    code="SAL001"
                    sql=""
                    isEditable={true}
                    onValueChanged={(value: string) => {
                      settpUmValue(value);
                    }}
                  />
                </div>
                <div style={{ width: 120 }}>
                  <SnButton text={"단가일괄변경"} onClick={changeUmBatch} />
                </div>
              </div>
            }
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={0}
          selectedDtDocu={selectedDtDocu}
        />
      </div>
    </div>
  );
});

export default SN_SAL_STX_REG_001;
